/**
 * Created by jv on 30/05/2018.
 */
import CONSTANTS from "Sources/games/chicken-game/config/constants";

export default class Chick extends Phaser.Physics.Arcade.Sprite
{
  constructor(scene, options)
  {
    if(!options.hatchPosition || !CONSTANTS.CHICK_HATCH_POSITIONS.includes(options.hatchPosition))
    {
      var index = Phaser.Math.Between(0, CONSTANTS.CHICK_HATCH_POSITIONS.length - 1);
      options.hatchPosition = CONSTANTS.CHICK_HATCH_POSITIONS[index];
    }

    super(scene, options.x, options.y, CONSTANTS.ATLAS_KEY, "animations/chicks/plop/" + options.hatchPosition + "/0001.png").setOrigin(0.5);

    this.spawnPosition = {
      x: options.x,
      y: options.y
    };
    this.hatchPosition = options.hatchPosition;
    this.draggable = false;
    this.onHatch = options.onHatch;

    this.hatching = false;

    this.escaped = false;
    this.runningOutside = false;

    this.runTween = null;
    this.runningTo = null;

    this.flashTween = null;

    this.on("animationcomplete", () =>
    {
      if(this.hatching)
      {
        this.hatching = false;
        if(typeof this.onHatch === "function") this.onHatch.call(null, this);
      }
    }, this);
  }

  hatch()
  {
    this.hatching = true;
    this.anims.play("chick-plop-" + this.hatchPosition, true);
  }

  runTo(x, y, duration, callback)
  {
    if(this.runTween !== null)
    {
      // Still running
      return;
    }

    this.runningTo = { x, y };

    var v = new Phaser.Math.Vector2(x-this.x, y-this.y).normalize();
    var cutoff = 0.35;

    this.startRunAnimation(this.getDirectionForVector(v, cutoff));

    duration = duration ? duration : 6000;

    this.runTween = this.scene.tweens.add({
      targets: this,
      props: {
        x: { value: x, duration: duration },
        y: { value: y, duration: duration }
      },
      onComplete: () =>
      {
        this.runTween = null;
        this.runningTo = null;
        this.anims.stop();
        if(typeof callback === "function")
        {
          callback.call(null, this);
        }
      }
    });
  }

  pauseRunning()
  {
    if(this.runTween !== null)
    {
      this.runTween.pause();
    }
  }

  resumeRunning()
  {
    if(this.runTween !== null)
    {
      this.runTween.resume();
    }
  }

  stopRunning()
  {
    if(this.runTween !== null)
    {
      this.runTween.stop();
      this.runningTo = null;
      this.runTween = null;
    }
  }

  startRunAnimation(direction)
  {
    this.anims.play("chick-run-" + direction, true);
  }

  flash()
  {
    var startColor = Phaser.Display.Color.HexStringToColor("#ff0000"),
        endColor = Phaser.Display.Color.HexStringToColor("#ffffff");

    if(this.flashTween !== null && this.flashTween.isPlaying())
    {
      // this.flashTween.stop();
      return;
    }

    var that = this;

    this.flashTween = this.scene.tweens.addCounter({
      from: 0,
      to: 100,
      loop: 1,
      duration: 1000,
      onUpdate: function()
      {
        that.tint = Phaser.Display.Color.ObjectToColor(Phaser.Display.Color.Interpolate.ColorWithColor(startColor, endColor, 100, that.flashTween.getValue())).color;
      },
      onComplete: function()
      {

      }
    });
  }

  getDirectionForVector(v, cutoff)
  {
    if((Math.abs(v.x) > 1 - cutoff && Math.abs(v.y) < 0 + cutoff) || (Math.abs(v.y) > 1 - cutoff && Math.abs(v.x) < 0 + cutoff))
    {
      var vAbs = { x: Math.abs(v.x), y: Math.abs(v.y) };

      if(v.x >= 0 && vAbs.x > vAbs.y)
      {
        return "e";
      }
      else if(v.x <= 0 && vAbs.x > vAbs.y)
      {
        return "w";
      }
      else if(v.y >= 0 && vAbs.y > vAbs.x)
      {
        return "s";
      }
      else if(v.y <= 0 && vAbs.y > vAbs.x)
      {
        return "n";
      }
    }
    else
    {
      if(v.x > 0 && v.y < 0)
      {
        return "ne";
      }
      else if(v.x > 0 && v.y > 0)
      {
        return "se";
      }
      else if(v.x < 0 && v.y < 0)
      {
        return "nw";
      }
      else if(v.x < 0 && v.y > 0)
      {
        return "sw";
      }
    }
  }
}



// WEBPACK FOOTER //
// ./app/js/games/chicken-game/objects/chick.js